import { createContext as e, useCallback as t, useContext as n, useLayoutEffect as r, useRef as i, useState as a } from "react";
import { jsx as o } from "react/jsx-runtime";
//#region src/shadcn/toaster-portal.tsx
var s = e(null), c = e(null), l = ({ children: e }) => {
	var n;
	let [i, l] = a([]), [u] = a(() => {
		if (typeof document > "u") return null;
		let e = document.createElement("div");
		return e.style.display = "contents", e.dataset.toasterPortalContainer = "", e;
	}), d = t((e) => (l((t) => [...t, e]), () => {
		l((t) => t.filter((t) => t !== e));
	}), []), f = (n = i[i.length - 1]) == null ? null : n;
	return r(() => {
		if (!u) return;
		let e = f == null ? document.body : f;
		return e.appendChild(u), () => {
			u.parentElement === e && e.removeChild(u);
		};
	}, [f, u]), /* @__PURE__ */ o(s.Provider, {
		value: d,
		children: /* @__PURE__ */ o(c.Provider, {
			value: u,
			children: e
		})
	});
}, u = () => {
	let e = n(s), t = i(null);
	return r(() => {
		if (!(!e || !t.current)) return e(t.current);
	}, [e]), /* @__PURE__ */ o("div", {
		ref: t,
		className: "contents",
		"data-toaster-portal-host": !0
	});
}, d = () => n(c);
//#endregion
export { u as ToasterPortalHost, l as ToasterPortalProvider, d as useToasterPortalContainer };
